// extracted by mini-css-extract-plugin
export default {"wrapper":"menu-modal_wrapper__8xaTM","boxBtn":"menu-modal_boxBtn__oI8Sx"};